import React, { useEffect } from 'react';

import { Button, Grid, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ShowErrors } from 'common/components';
import {
    ReactHookFormDragnDropFile,
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form/RHF';
import { getSystemTypesOptions } from 'common/utils/helpers';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate';

const AttachmentForm = ({
    closeModal,
    errors,
    initialValues,
    isSaving,
    save,
    systemTypes,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    const handleOnChangeFile = (value) => setValue('attachment_file', value[0]);

    useEffect(() => {
        reset(initialValues);
    }, [initialValues]);

    return (
        <form>
            <Grid container>
                <Grid size={18}>
                    <ReactHookFormInput
                        control={control}
                        label={t('Name').concat(' *')}
                        name="name"
                    />
                </Grid>

                <Grid size={18}>
                    <ReactHookFormSelect
                        autoComplete="off"
                        control={control}
                        label={t('System type').concat(' *')}
                        name="system"
                        options={getSystemTypesOptions(systemTypes)}
                    />
                </Grid>

                <Grid size={18}>
                    <ReactHookFormDragnDropFile
                        accept=".pdf,application/pdf,image/png,image/jpeg,image/jpg"
                        control={control}
                        formats="pdf, jpg, jpeg, png"
                        id="attachment_file"
                        onChange={handleOnChangeFile}
                        name="file"
                        setValue={setValue}
                    />
                </Grid>
            </Grid>

            <ShowErrors
                errors={errors}
                mt={2}
                severity="error"
                variant="filled"
            />

            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                mt={2}
            >
                <Grid container spacing={2} justifyContent="flex-end">
                    <Grid>
                        <Button onClick={() => closeModal()} variant="outlined">
                            {t('Cancel')}
                        </Button>
                    </Grid>
                    <Grid>
                        <Button
                            disabled={isSaving}
                            onClick={handleSubmit(save)}
                        >
                            {isSaving ? `${t('Saving')}...` : t('Save')}
                        </Button>
                    </Grid>
                </Grid>
            </Stack>
        </form>
    );
};

AttachmentForm.propTypes = {
    closeModal: PropTypes.func,
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isSaving: PropTypes.bool,
    save: PropTypes.func,
    systemTypes: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getErrorsSave,
    initialValues: selectors.getInitialValues,
    isSaving: selectors.getIsSaving,
});

const mapDispatchToProps = (dispatch) => ({
    save: (values) => dispatch(actions.save(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentForm);
